import { sendCPCLog } from "../../utils/common";

function onFirstLoad(anchors, cpcType) {
  const io = new IntersectionObserver((entries, observer) => {
    const filtered = entries
      .filter((entry) => entry.isIntersecting)
      .map(({ target }) => {
        observer.unobserve(target);
        target.dataset.cpc = true;
        return { href: target.href };
      });
    if (filtered.length > 0) sendCPCLog(filtered, 'IMPRESSION', cpcType);
  }, { threshold: 0.5 });
  anchors
    .filter((anchor) => anchor.dataset.ad === 'true')
    .forEach((anchor) => io.observe(anchor));
}

let timer = null;

function onScrollEnd(container, cpcType) {
  container.onscroll = (e) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      const anchors = [...container.querySelectorAll('li > a')];
      const scrollLeft = e.target.scrollLeft + e.target.clientWidth;
      const filtered = anchors
      .filter((anchor) => anchor.dataset.ad === 'true')
      .filter((anchor) => anchor.dataset.cpc !== 'true')
      .filter((anchor) => {
        const anchorLeft = anchor.offsetLeft + anchor.offsetWidth;
        const isPassed = anchorLeft < scrollLeft;
        anchor.dataset.cpc = isPassed;
        return isPassed;
      });
    if (filtered.length > 0) sendCPCLog(filtered, 'IMPRESSION', cpcType);
    }, 400);
  };
}

function onSlideEnd(anchors, page, pageTotal, cpcType) {
  const start = (page - 1) * 6;
  const filtered = anchors.slice(start, start + pageTotal)
    .filter((anchor) => anchor.dataset.ad === 'true')
    .filter((anchor) => anchor.dataset.cpc !== 'true')
    .map((anchor) => {
      anchor.dataset.cpc = true;
      return { href: anchor.href };
    });
  if (filtered.length > 0) sendCPCLog(filtered, 'IMPRESSION', cpcType);
}

export {
  onFirstLoad,
  onScrollEnd,
  onSlideEnd,
};
